import { styled } from '@mui/material';

import { generateClasses } from '../../../../utils/helper';
import CourseWidget from '../../../course/CourseWidget';
import { WidgetWrapperRadioOption } from '../../styles';

export const courseListClasses = generateClasses('CourseList', ['courseCard', 'selectedCourse']);

export const RadioOption = styled(WidgetWrapperRadioOption)(() => ({
  [`& .${courseListClasses.courseCard}`]: {
    // flex property should work here because RadioOption is a flex container
    flex: 1,
  },
}));

export const CourseCard = styled(CourseWidget)(({ theme }) => ({
  [`&.${courseListClasses.selectedCourse}`]: {
    borderColor: 'transparent',
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: -2,
  },
}));
